import { BrowserRouter, Route, Routes, useLocation } from 'react-router-dom';
import { lazy, Suspense } from 'react';
import LandingPage from './pages/LandingPage';
import ThankYouPage from './pages/ThankYouPage';
import { GoogleTranslator } from './components/GoogleTranslator';
import './App.css';
import './styles/brand.css';

const AdminApp = lazy(() => import('./pages/admin/AdminApp'));
const PublicTranslator = () => {
  const location = useLocation();
  return /^\/admin(?:\/|$)/.test(location.pathname) ? null : <GoogleTranslator />;
};

export default function App() {
  return <BrowserRouter>
    <PublicTranslator />
    <Routes>
      <Route path="/thank-you" element={<ThankYouPage />} />
      <Route path="/admin/*" element={<Suspense fallback={<div className="page-status" data-testid="admin-page-loading">Loading…</div>}><AdminApp /></Suspense>} />
      <Route path="*" element={<LandingPage />} />
    </Routes>
  </BrowserRouter>;
}